(function(angular){
	'use strict';
	
	angular
		.module('ratingsAndReviewsModule')
		.controller('RatingsAndReviews', [
			'mixpanelFactory',
			'RatingsAndReviewsFactory',
			RatingsAndReviewsFunction
		]);
	
	function RatingsAndReviewsFunction(
		mixpanelFactory,
		RatingsAndReviewsFactory
	){
		var RatingsAndReviews = this;

		RatingsAndReviews.$onInit = function() {
			RatingsAndReviews.visibleItems = 20;
			RatingsAndReviews.orderOptions = [{
				label: 'Most recent',
				value: '-date'
			},{
				label: 'Most helpful',
				value: '-helpfulCount'
			}];
			RatingsAndReviews.orderBy = RatingsAndReviews.orderOptions[0];

			RatingsAndReviewsFactory.getFormattedReviews()
				.then(function(formattedReviews) {
					RatingsAndReviews.reviews = formattedReviews;
				});
		};
		
		RatingsAndReviews.trackSortChange = function(selectedSort) {
			mixpanelFactory.track('Ratings and Reviews Sort Changed', {
				'Sort' : selectedSort.label
			});
		};
		
		RatingsAndReviews.showMore = function() {
			RatingsAndReviews.visibleItems += 20;

			mixpanelFactory.track('Ratings and Reviews Show More Clicked', {
				'Items Visible' : RatingsAndReviews.visibleItems
			});
		};
		
		RatingsAndReviews.ratingBgPosition = function(rating) {
			return {
				backgroundPosition: 100 - (rating * 20) + '%'
			};
		};
	}
})(window.angular);